import * as React from 'react';
import { useRef, useEffect } from 'react';

interface Props {
	isOpen: boolean;
	onFocus: (event?: React.FocusEvent<HTMLInputElement>) => void;
	onBlur: (event?: React.FocusEvent<HTMLInputElement>) => void;
}

const SyncFieldFocus: React.FC<Props> = ({ isOpen, onFocus, onBlur }) => {
	const wasOpenRef = useRef(false);

	useEffect(() => {
		if (isOpen === wasOpenRef.current) {
			return;
		}

		if (isOpen) {
			onFocus();
		} else {
			onBlur();
		}

		wasOpenRef.current = isOpen;
	}, [isOpen, onFocus, onBlur]);

	return null;
};

export default SyncFieldFocus;
